/**
 * Layouts rendered by the native Google Mobile Ads SDK.
 *
 * The dimensions of a native ad slot must remain stable while it is used by a
 * virtual scroller. `small` is intended for compact rows, while `medium`
 * includes a larger media area.
 */
export var NativeAdTemplate;
(function (NativeAdTemplate) {
    NativeAdTemplate["Small"] = "small";
    NativeAdTemplate["Medium"] = "medium";
})(NativeAdTemplate || (NativeAdTemplate = {}));
//# sourceMappingURL=native-ad-template.enum.js.map